import styled from 'styled-components';

export const Label = styled.div`
  color: #5e7698;
  text-decoration: ${({ textUnderLine }) => (textUnderLine ? 'underline' : '')};
`;
